
import {CATEGORIES} from 'consts/categories'
const __default__ = {
  props: {
    type: {type: String, default: 'other'},
    label: {type: String, default: undefined},
    size: {type: String, default: '1.2rem'},
    showIcon: {type: Boolean, default: true}
  },
  computed: {
    category() {
      return CATEGORIES.find(x => x.type === this.type)
    },
    color(){
      return this.category.color
    },
    icon() {
      return this.category.icon
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b88f5f28-color": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__